export enum SwapCardType {
  SENDER,
  RECEIVER
}
